<div class="page-layout simple">
  <div class="toolbar second-level-toolbar flex flex-row justify-start items-center">
    <!--TODO: BACK BUTTON-->
    <div>
      <button class="mr-sm-16 mat-icon-button back-btn" mat-icon-button="" tabindex="0"
              (click)="navigateToPreviousRoute()">
        <mat-icon class="mat-icon ng-tns-c39-36 material-icons" role="img"
                  aria-hidden="true">arrow_back
        </mat-icon>
      </button>
    </div>

    <!--<particle-filter-summary [filterKey]="filterKey">
    </particle-filter-summary>-->
  </div>
  <mat-sidenav-container class="particle-page-content-container">
    <div class="content" >
      <div class="responsive-scroll">
        <particle-filter-tab [filterKey]="filterKey">

        </particle-filter-tab>
      </div>
    </div>
  </mat-sidenav-container>
</div>

